export default __webpack_public_path__ + "static/media/button_large.43e5f008.png";